import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const DigerSaglikPersoneliPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // SEO Meta Tags
    document.title = 'Diğer Sağlık Personeli | Adana OSGB Mersin Hatay Osmaniye | ASSA';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Adana diğer sağlık personeli, Mersin diğer sağlık personeli, Hatay diğer sağlık personeli, Osmaniye diğer sağlık personeli hizmetleri. Hemşire, sağlık memuru, ilk yardım. ASSA OSGB profesyonel destek.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Adana diğer sağlık personeli, Mersin diğer sağlık personeli, Hatay diğer sağlık personeli, Osmaniye diğer sağlık personeli, OSGB hemşire, sağlık memuru');
    }

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://www.assaosgb.com.tr/osgb/diger-saglik-personeli');
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Diğer Sağlık Personeli Hizmetleri",
      "description": "Adana, Mersin, Hatay, Osmaniye bölgelerinde profesyonel diğer sağlık personeli hizmetleri. Hemşire, sağlık memuru, ilk yardım.",
      "provider": {
        "@type": "Organization",
        "name": "ASSA OSGB",
        "telephone": "+90-850-346-2772",
        "email": "assa@assaisg.com"
      },
      "areaServed": [
        {"@type": "City", "name": "Adana"},
        {"@type": "City", "name": "Mersin"},
        {"@type": "City", "name": "Hatay"},
        {"@type": "City", "name": "Osmaniye"}
      ],
      "serviceType": "Diğer Sağlık Personeli",
      "url": "https://www.assaosgb.com.tr/osgb/diger-saglik-personeli"
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <FloatingButtons />

      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-br from-green-50 to-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Diğer Sağlık Personeli Hizmetleri
            </h1>
            <p className="text-xl text-gray-600 mb-8">
              <strong>Adana OSGB</strong>, <strong>Mersin OSGB</strong>, <strong>Hatay OSGB</strong> ve <strong>Osmaniye OSGB</strong> bölgelerinde hemşire, sağlık memuru ve diğer sağlık personeli hizmetleri sunuyoruz. İşyerinizde sağlık hizmetlerini eksiksiz yürütmek için yanınızdayız.
            </p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              Diğer Sağlık Personeli Hizmetlerimiz
            </h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Service Card 1 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-nurse-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Hemşire Hizmeti</h3>
                <p className="text-gray-600">
                  İşyeri revir hemşireliği ve sağlık takibi. <strong>Adana diğer sağlık personeli</strong> hizmetlerimizle çalışan sağlığını koruyoruz.
                </p>
              </div>

              {/* Service Card 2 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-syringe-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Sağlık Memuru</h3>
                <p className="text-gray-600">
                  Temel sağlık hizmetleri ve ilk müdahale. <strong>Mersin OSGB diğer sağlık personeli</strong> olarak profesyonel destek sağlıyoruz.
                </p>
              </div>

              {/* Service Card 3 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-medicine-bottle-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">İlaç Yönetimi</h3>
                <p className="text-gray-600">
                  Revir ilaç stoğu yönetimi ve takibi. <strong>Hatay OSGB</strong> bölgesinde güvenilir hizmet sunuyoruz.
                </p>
              </div>

              {/* Service Card 4 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-heart-add-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">İlk Yardım</h3>
                <p className="text-gray-600">
                  Acil durumlarda ilk yardım müdahalesi. <strong>Osmaniye diğer sağlık personeli</strong> hizmetlerimizle güvende olun.
                </p>
              </div>

              {/* Service Card 5 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-health-book-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Sağlık Kayıtları</h3>
                <p className="text-gray-600">
                  Çalışan sağlık kayıtlarının tutulması ve arşivlenmesi. <strong>Adana OSGB</strong> standartlarında hizmet.
                </p>
              </div>

              {/* Service Card 6 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-mental-health-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Sağlık Eğitimleri</h3>
                <p className="text-gray-600">
                  Çalışanlara yönelik sağlık eğitimleri ve bilgilendirme. <strong>Mersin diğer sağlık personeli</strong> desteğiyle.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Regional Coverage */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              Hizmet Bölgelerimiz
            </h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl text-green-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Adana OSGB</h3>
                <p className="text-gray-600">
                  Adana ve çevresinde <strong>diğer sağlık personeli</strong> hizmetleri
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl text-green-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Mersin OSGB</h3>
                <p className="text-gray-600">
                  Mersin bölgesinde profesyonel <strong>diğer sağlık personeli</strong> desteği
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl text-green-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Hatay OSGB</h3>
                <p className="text-gray-600">
                  Hatay'da güvenilir <strong>diğer sağlık personeli</strong> hizmetleri
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl text-green-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Osmaniye OSGB</h3>
                <p className="text-gray-600">
                  Osmaniye'de uzman <strong>diğer sağlık personeli</strong> kadrosu
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-green-600">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Diğer Sağlık Personeli Hizmeti Almak İster misiniz?
            </h2>
            <p className="text-xl text-white/90 mb-8">
              <strong>Adana OSGB</strong>, <strong>Mersin OSGB</strong>, <strong>Hatay OSGB</strong> ve <strong>Osmaniye OSGB</strong> bölgelerinde profesyonel diğer sağlık personeli hizmetleri için bizimle iletişime geçin.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/iletisim" 
                className="bg-white text-green-600 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap"
              >
                Hemen İletişime Geçin
              </Link>
              <a 
                href="tel:08503462772" 
                className="bg-green-700 text-white px-8 py-4 rounded-lg font-bold hover:bg-green-800 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                0850 346 2772
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DigerSaglikPersoneliPage;
